module.exports = __webpack_public_path__ + "static/media/1.23.547a5c5e.png";